<template>
    <div class="relative bg-wrap-color">
        <template v-if="isPageAllowedNew&&isPageAllowed">
            <div style="transition: none;" v-show="getTabShow(componentName)">
                <div class="tab-bar relative">
                    <el-tabs v-model="activeTabName" @tab-click="changeTab">
                        <el-tab-pane label="工单管理" name="MaterialPage" v-if="pageActionNames.indexOf('Material') > -1"></el-tab-pane>
                        <!-- 预排期管理 tab 废弃（阶段16）：待排单/一键预排已并入「排单管理」5 tab -->
                        <el-tab-pane label="排单管理" name="ScheduleManagePage" v-if="pageActionNames.indexOf('ScheduleManage') > -1"></el-tab-pane>
                        <el-tab-pane label="指派管理" name="AssignPage" v-if="pageActionNames.indexOf('Assign') > -1"></el-tab-pane>
                        <el-tab-pane label="任务管理" name="TaskPage" v-if="pageActionNames.indexOf('Task') > -1"></el-tab-pane>
                    </el-tabs>
                </div>
            </div>
            <div class="pl10 pr10">
                <keep-alive :include="keepList">
                    <component
                        :is="componentName"
                        @changePage="handleChangePage"
                        @close="handleCreateClose"
                        :query="$route.query"
                        :reload="reload"
                        :data="actionData"
                        :type="actionType"
                        :pageFuncNames="tabFuncNames"
                        :approvalFuncNames="approvalFuncNames"
                        :formatDateColor="formatDateColor"
                    />
                </keep-alive>
            </div>
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>素材工单</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>


<script>
import MaterialPage from './pages/material/index.vue'
import MaterialInfoPage from './pages/materialInfo/index.vue'
import AssignPage from './pages/assign/index.vue'
import AssignInfoPage from './pages/assignInfo/index.vue'
import TaskPage from './pages/task/index.vue'
import TaskInfoPage from './pages/taskInfo/index.vue'
import ScheduleManagePage from './pages/scheduleManage/index.vue'
import CreatePage from './pages/create/index';
import NoPermissionInfo from "@/components/noPermissionInfo.vue";
import {pageMixin} from '../../mixins/pageMixin';
import {mapState, mapMutations} from 'vuex'
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isBetween from 'dayjs/plugin/isBetween'
dayjs.extend(isSameOrAfter)
dayjs.extend(isBetween)
export default {
    name: 'material',
    mixins: [pageMixin],
    components: {
        NoPermissionInfo,
        MaterialPage,
        MaterialInfoPage,
        AssignPage,
        AssignInfoPage,
        TaskPage,
        TaskInfoPage,
        ScheduleManagePage,
        CreatePage,
    },
    data() {
        return {
            create_show: true,  //创建页面
            auchTabName: '',  //确定跳转后的权限问题 与 activeTabName 保存完全一致
            activeTabName:'',
            componentName: '',
            keepList:[], //,'AssignPage','TaskPage'
            query: {}, //传入对象
            reload: '', //更新接口
            actionData:{},
            actionType:'',
            curKey: 1,
            isPageAllowedNew : true,
        }
    },
    computed:{
        tabFunc(){
            let actionTab = (this.pageAction||[]).map(item=>{
                if(item.name === 'work_order_list') {
                    item.name = 'Material';
                }else if(item.name === 'work_order_assign_list') {
                    item.name = 'Assign'
                }else if(item.name === 'work_order_quest') {
                    item.name = 'Task'
                }else if(item.name === 'wos_pre_schedule') {
                    // 阶段16：预排期管理废弃·重定向到排单管理（待排单已并入）
                    item.name = 'ScheduleManage'
                }else if(item.name === 'wos_schedule_manage') {
                    item.name = 'ScheduleManage'
                }
                return {...item}
            }).find(item=>this.auchTabName.indexOf(item.name) !== -1);
            if(actionTab){
                return actionTab.func||[];
            }
            return [];
        },
        tabFuncNames(){
            return (this.tabFunc||[]).map(item=>item.name);
        },
        // 审批 tab(wos_approval)的功能节点，透传给排单管理容器内的「审批」子tab
        // 阶段15：审批改双签会签(按组织树leader自动定签人·无tier功能节点)，持 wos_approval 即显审批tab；会签人 gating 由后端 per-row(my_ops_pending/my_creative_pending) 控
        approvalFuncNames(){
            const list = this.pageAction || [];
            // ① 旧形态：wos_approval 仍是 pageAction 顶层 tab（remap 后名 Approval）
            const t = list.find(item=>item.name==='Approval' || item.name==='wos_approval');
            if (t) {
                const funcs = (t.func||[]).map(f=>f.name);
                return funcs.length ? funcs : ['wos_approval'];
            }
            // ② 阶段16 SQL-04：wos_approval 降为 wos_schedule_manage 下的功能节点(type=2)，
            //    不再是顶层 tab，须在排单管理 tab 的 func 子节点里找
            const sm = list.find(item=>item.name==='wos_schedule_manage' || item.name==='ScheduleManage');
            const smFuncs = sm ? (sm.func||[]).map(f=>f.name) : [];
            return smFuncs.includes('wos_approval') ? ['wos_approval'] : [];
        },
        ...mapState({
            isCreateWorkOrdering: state => state.workOrder.isCreateWorkOrdering,
        }),
    },
    watch:{
        $route(to, from) {
            // 在路由变化时执行的代码   点击menu 让页面刷新
            // if(!to.params?.menuReload) {
            //     console.log('----', '为什么请求', to.params?.menuReload)
            //     this.initPageStates()
            // }
            
            setTimeout(()=>{
                this.initPageStates()
            }, 100)

        }
    },
    created() {
        // this.$router.replace({name:'work_order_material', query:{}})
    },
    mounted() {
    },
    methods:{
        ...mapMutations('app', [
            'CLEAR_BREADCRUMB',
        ]),
        
        formatDateColor(date) {
            if (!date) return '';
            if(dayjs(date).isBefore(dayjs().add(1, 'day'),'day')) {
                return 'red'
            }
            if(dayjs(date).isBetween(dayjs().add(4, 'day'),dayjs(), 'day', '(]')) {
                return 'orange'
            }
            return ''
        },
        initPageStates() {
            let cur_names = this.pageAction.map(item=>{
                if(item.name === 'work_order_list') {
                    item.name = 'Material';
                }else if(item.name === 'work_order_assign_list') {
                    item.name = 'Assign'
                }else if(item.name === 'work_order_quest') {
                    item.name = 'Task'
                }else if(item.name === 'wos_pre_schedule') {
                    // 阶段16：预排期管理废弃·重定向到排单管理（待排单已并入）
                    item.name = 'ScheduleManage'
                }else if(item.name === 'wos_schedule_manage') {
                    item.name = 'ScheduleManage'
                }
                return item.name
            })

            if(cur_names && cur_names.length !==0) {
                let actions_auth = (this.pageAction||[]).filter(item=>{
                    if(this.$route.query.topage === 'TaskInfoPage') {
                        return item.name === 'Task'
                    }else if(this.$route.query.topage === 'AssignInfoPage') {
                        return item.name === 'Assign'
                    }else if(this.$route.query.topage === 'MaterialInfoPage') {
                        return item.name === 'Material'
                    }else if(this.$route.query.topage === 'CreatePage') {
                        return item.name === 'Material'
                    }
                }).reduce((pre, item)=>{
                    return pre.concat(...item.func.map(v=>v.name))
                }, [])
                console.log('actions_auth', actions_auth)

                // 由列队页面跳转任务管理-工单想请你
                if(this.$route.query.topage === 'TaskInfoPage') {
                    if(cur_names.indexOf('Task') === -1 || actions_auth.indexOf('work_order_info') === -1) {
                        this.isPageAllowedNew = false
                        return
                    }
                    this.handleChangeRoutePage(this.$route.query)
                }else if(this.$route.query.topage === 'AssignInfoPage') {
                    if(cur_names.indexOf('Assign') === -1) {
                        this.isPageAllowedNew = false
                    }else{
                        if(this.$route.query?.tagsActive == '1' && actions_auth.indexOf('work_order_assign') === -1) {
                            this.isPageAllowedNew = false
                        }else if(this.$route.query?.actionType == '2' && actions_auth.indexOf('reject_work_order') === -1) {
                            this.isPageAllowedNew = false
                        }else{
                            this.handleChangeRoutePage(this.$route.query)
                        }
                    }
                }else if(this.$route.query.topage === 'MaterialInfoPage') {
                    if(cur_names.indexOf('Material') === -1 || actions_auth.indexOf('work_order_info') === -1) {
                        this.isPageAllowedNew = false
                        return
                    }
                    this.handleChangeRoutePage(this.$route.query)
                }else if(this.$route.query.topage === 'CreatePage') {
                    if(cur_names.indexOf('Material') === -1) {
                        this.isPageAllowedNew = false
                    }else{
                        if(this.$route.query?.actionType == 'copy' && actions_auth.indexOf('work_order_copy') === -1) {
                            this.isPageAllowedNew = false
                        }else if(this.$route.query?.actionType == 'edit' && actions_auth.indexOf('edit_work_order') === -1) {
                            this.isPageAllowedNew = false
                        }else if(this.$route.query?.actionType == 'add' && actions_auth.indexOf('add_work_order') === -1) {
                            this.isPageAllowedNew = false
                        }else{
                            this.handleChangeRoutePage(this.$route.query)
                        }
                    }
                }else{
                    let cur_topage = this.$route.query.topage
                    let cur_name_list = cur_names.map(item => `${item}Page`)
                    if(cur_name_list.includes(cur_topage)) {
                        console.log('有权限', cur_name_list, cur_topage)
                        // 有权限
                        this.keepList = [cur_topage]
                        this.changeRouteName(cur_topage)
                        this.handleChangeRoutePage(this.$route.query)
                    }else{
                        // 无明确 topage → 默认落地：显式优先级 工单管理 > 排单管理 > 指派管理 > 任务管理
                        // （创意无工单管理·有排单管理 → 默认进排单管理·2026-07-08；不依赖后端节点顺序）
                        const defaultName = ['Material', 'ScheduleManage', 'Assign', 'Task'].find(p => cur_names.includes(p)) || cur_names[0]
                        this.keepList = [`${defaultName}Page`]
                        this.changeRouteName(`${defaultName}Page`)

                        this.handleChangeRoutePage({topage:`${defaultName}Page`})
                    }
                }
            }else{
                this.isPageAllowedNew = false
            }
        },
        changeRouteName(name) {
            this.keepList = [name]
            this.$router.push({
                name:'work_order_material',
                query: {
                    ...this.$route.query,
                    topage: name
                },
                params:{
                    menuReload: 1
                }
            });
        },
        getTabShow(name) {
            return ['MaterialPage', 'AssignPage', 'TaskPage', 'ScheduleManagePage'].includes(name)
        },
        changeTab(tab){
            let active_name = tab.name ? tab.name : ''

            this.keepList = active_name ? [active_name] : [];
            this.$router.push({
                name:'work_order_material',
                query: {
                    topage: active_name
                },
                params:{
                    menuReload: 1
                }
            });
        },
        handleCreateClose(){
            this.create_show = false;
        },
        /**
         *
         * @param url    跳转的页面
         * @param params  参数传递 对象
         * @param type  页面刷新方式  add  copy  edit
         */
        handleChangePage(url, params,type) {
        },

        handleChangeRoutePage(params){
            this.reload = ''
            // 设置一下权限 权限变量名与url不一致
            let auch_list = ['Material', 'Assign', 'Task', 'ScheduleManage']
            if(params.topage === 'CreatePage') {
                this.auchTabName = '"MaterialPage"'
                this.activeTabName = '"MaterialPage"'
            }else{
                auch_list.forEach(item=>{
                    if(params.topage.indexOf(item) !== -1) {
                        let name = `${item}Page`
                        if(name === 'MaterialPage') {
                            this.keepList = ['MaterialPage']
                        }else if(name === 'AssignPage') {
                            this.keepList = ['AssignPage']
                        }else if(name === 'TaskPage') {
                            this.keepList = ['TaskPage']
                        }else if(name === 'ScheduleManagePage') {
                            this.keepList = ['ScheduleManagePage']
                        }
                        this.$nextTick(()=>{
                            this.auchTabName = name
                            this.activeTabName = name
                        })
                    }
                })
            }
            
            this.componentName = params.topage;
            if(this.componentName ==='MaterialPage' || this.componentName ==='AssignPage') {
                this.$nextTick(()=>{
                    this.reload = params.reload
                })
            }
            
        }
    },
    beforeRouteLeave(to, from, next) {
        this.CLEAR_BREADCRUMB()
        if(!this.isCreateWorkOrdering){
            next();
        }else{
            this.$confirm('您确定要离开吗？', '温馨提示', {
                confirmButtonText: '离开',
                type: 'warning',
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false
            }).then(() => {
                next();
            }).catch(() => {
            });
        }
    },
}
</script>

<style lang="scss" scoped>
.tab-bar::after{
    content: '';
    position: absolute;
    left: -20px;
    right: -20px;
    background-color: #fff;
}
.tab-bar ::v-deep .el-tabs__header{
    background-color: #fff;
    margin-bottom: 10px;
    .el-tabs__nav-wrap{
        padding-left: 30px;
    }
    .el-tabs__active-bar {
        min-width: 56px;
    }
}
.tab-bar ::v-deep .el-tab-pane{
    margin: 0 15px;
}
.bg-wrap-color{
    padding: 0;
    background-color:#F1F4F9;
}
</style>
